import Loadable from "app/components/Loadable";
import React, { lazy } from "react";

const ReportsList = Loadable(lazy(() => import("./ReportsList"))); 

const reportsRoutes = [
    { path: "/reports/list", element: <ReportsList/> },
];

export default reportsRoutes;